import React from "react";
import ReportItem from "../ReportItem";
import Block from "./Block";

export default function MultiBlock({
  items,
  report,
  loading,
  title,
  description,
  ...other
}) {
  return (
    <ReportItem {...other}>
      {title !== undefined && (
        <div className="report-item__heading">
          <h2 className="report-item__heading-title">{title}</h2>
        </div>
      )}
      {description && (
        <p className="report-item__heading-description">{description}</p>
      )}
      {items.map((item, index) => (
        <Block
          key={item.id ?? index}
          sectionData={item}
          report={report}
          loading={loading}
          title={title !== undefined}
        />
      ))}
    </ReportItem>
  );
}
